import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface Props {
  onGuideClose(): void
}

export const GuideConfirmationModal: BaseModalType<Props> = (props) => {
  const { onGuideClose, close } = props

  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Close Quick Guidelines')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>{t('Are you sure you want to close Quick Guidelines?')}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={onGuideClose}>{t('Close Guidelines')}</Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
